import React, { Component } from 'react';

import Logo from '../logo';

class PublicFooter extends Component {
    render() {
        return (
            <footer className="Footer">
                <div className="Footer__section">
                    <img
                        className="EHSLogo"
                        src="/images/EHS_Final_Logo_White.png"
                        alt="EHS"
                    />
                    <br />
                    &copy; 2018 Evolutionary Health Solutions.
                </div>

                <div className="Footer__section">
                    <Logo />
                    <span>A Clear, Connected Path to Your Success</span>
                </div>

                <div className="Footer__section">
                    <h3>Contact Us</h3>
                    <p>
                        Email:{' '}
                        <a href="mailto:info@evolutionaryhealthsolutions.com?subject=Web Contact">
                            info@evolutionaryhealthsolutions.com
                        </a>
                    </p>
                    <p>
                        Web:{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.evolutionaryhealthsolutions.com">
                            www.evolutionaryhealthsolutions.com
                        </a>
                    </p>
                </div>
            </footer>
        );
    }
}

export default PublicFooter;
